import type { RootData } from '~/definitions/AllDefinitions'

export default defineNuxtPlugin({
  name: 'GTM',
  hooks: {
    // wait for rootData to be ready as we will use rootData.stripeAccount
    'rootData:ready'(rootData: RootData) {
      if (process.env.NODE_ENV !== 'production') {
        return
      }
      if (typeof document === 'undefined') {
        return
      }
      /*
         ** Tag Manager
         */
      if (rootData.gtmTagId) {
        /*
         ** tag Manager
         */
        const w = window as unknown as Record<string, Record<string, unknown>[]>
        w.dataLayer = w.dataLayer || []
        w.dataLayer.push({ 'gtm.start': new Date().getTime(), 'event': 'gtm.js' })
        const f = document.getElementsByTagName('script')[0]
        const j = document.createElement('script')
        j.async = true
        j.src = `https://www.googletagmanager.com/gtm.js?id=${rootData.gtmTagId}`
        f.parentNode?.insertBefore(j, f)
      }
    },
  },
})
// nuxtApp.provide('setGTM', (rootData) => {
//   /*
//    ** Only run on client-side and only in production mode or comment for testing
//    */
//   if (process.env.NODE_ENV !== 'production') {
//     return
//   }
//   if (typeof document === 'undefined') {
//     return
//   }
//   /*
//    ** Tag Manager
//    */
//   if (rootData.gtmTagId) {
//     /*
//      ** tag Manager
//      */
//     (function (w, d, s, l, i) {
//       w[l] = w[l] || []
//       w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
//       const f = d.getElementsByTagName(s)[0]
//       const j = d.createElement(s)
//       const dl = l !== 'dataLayer' ? '&l=' + l : ''
//       j.async = true
//       j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
//       f.parentNode.insertBefore(j, f)
//     })(window, document, 'script', 'dataLayer', rootData.gtmTagId)
//   }
// })
// })
